import type {PublicMethodUtils} from '@wix/document-services-types'
import type {ObservablesPublicAPI} from '@wix/document-services-public-types'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<ObservablesPublicAPI> {
    return {
        methods: {
            observables: {
                registerObservableNotifier: publicMethodUtils.extensionPublicAPI.immediate(
                    'observables.registerObservableNotifier'
                )
            }
        }
    }
}
